import {Icon, Layout, Text} from '@eitje/web_components'
import {FIRM_ICON_MAPPING} from './firm_icon_mapping'

export const FirmNameCell = ({row}) => {
	const {name, naam, company_name, tableName} = row.original
	const icon = FIRM_ICON_MAPPING[tableName]

	return (
		<Layout gap={8}>
			<Icon name={icon} size={14} />
			<Text truncate>{name || naam || company_name}</Text>
		</Layout>
	)
}
